module.exports = __webpack_public_path__ + "static/media/firebase.4b170e3a.svg";